module.exports = __webpack_public_path__ + "static/media/OSMB01.2a8be815.jpg";